"use client";

import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const features = [{
  number: "01",
  title: "Engenharia de Precisão.",
  body: "Sistemas de pulverização desenhados para máxima eficiência, reduzindo desperdícios e otimizando processos industriais complexos.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/engenharia_precisao.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/engenharia_precisao.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/engenharia_precisao.png-wvc-sizes",
  alt: "Sistema de engenharia industrial com bicos de alta precisão em ambiente fabril",
  imageLeft: true,
  href: "/ProductsPage"
}, {
  number: "02",
  title: "Controlo Total.",
  body: "Monitorização em tempo real e automação avançada para garantir consistência absoluta em todas as linhas de produção.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/controlo_industrial.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/controlo_industrial.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/controlo_industrial.png-wvc-sizes",
  alt: "Painel de controlo de sistemas de pulverização automatizados",
  imageLeft: false,
  href: "/AutomatedSprayingSystemsPage"
}, {
  number: "03",
  title: "Soluções Sustentáveis.",
  body: "Tecnologia focada na redução do consumo de recursos, alinhada com as normas ambientais mais exigentes do mercado.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/sustentabilidade_industrial.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/sustentabilidade_industrial.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/sustentabilidade_industrial.png-wvc-sizes",
  alt: "Equipamento industrial moderno focado em eficiência energética e sustentabilidade",
  imageLeft: true,
  href: "/SustainabilityPage"
}];
export default function Industrialcasestudydetail() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".vlt-eyebrow", {
        y: 16
      });
      gsap.set(".vlt-heading", {
        y: 24
      });
      gsap.to(".vlt-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".vlt-header",
          start: "top 85%",
          once: true
        }
      });
      gsap.to(".vlt-heading", {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: "power3.out",
        delay: 0.08,
        scrollTrigger: {
          trigger: ".vlt-header",
          start: "top 85%",
          once: true
        }
      });
      const rows = gsap.utils.toArray<HTMLElement>(".vlt-row");
      rows.forEach(row => {
        const image = row.querySelector(".vlt-image");
        const textEls = row.querySelectorAll(".vlt-text > *");
        if (image) {
          gsap.set(image, {
            scale: 1.04,
            y: 40
          });
          gsap.to(image, {
            opacity: 1,
            scale: 1,
            y: 0,
            duration: 1.1,
            ease: "power3.out",
            scrollTrigger: {
              trigger: row,
              start: "top 80%",
              once: true
            }
          });
        }
        gsap.set(textEls, {
          y: 24
        });
        gsap.to(textEls, {
          opacity: 1,
          y: 0,
          duration: 0.75,
          ease: "power3.out",
          stagger: 0.08,
          scrollTrigger: {
            trigger: row,
            start: "top 78%",
            once: true
          }
        });
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".vlt-eyebrow", ".vlt-heading", ".vlt-image", ".vlt-row .vlt-text > *"], {
        opacity: 1,
        y: 0,
        scale: 1
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return;
}